import React, { createContext, useContext } from 'react';
import { useAuthSync } from '../hooks/useAuthSync';

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
    const authData = useAuthSync();

    return (
        <UserContext.Provider value={authData}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUser must be used within a UserProvider');
    }
    return context;
};
